import { useState } from 'react';
import InitFiltersDetails from './ProfileListDetail/constants/InitFiltering';

const useCustomHook = () => {
  const [loading, setLoading] = useState(false);
  const [filterParams, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [filtersDeials, setFiltersDetail] = useState(InitFiltersDetails());
  const [isNewDialogOpen, setIsNewDialogOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [toolsPayData, setToolsPayData] = useState(null);
  const [payDueDate, setPayDueDate] = useState(null);
  const [amountPercentage, setAmountPercentage] = useState(100);
  const [payerId, setPayerId] = useState(null);
  const [totalList, setTotalList] = useState([]);
  const [dataRow, setdataRow] = useState([]);
  const [valueAmount, setValueAmount] = useState(0);
  const [activeStep, setActiveStep] = useState(0);// کلید مربوط به استپ های ویزارد
  const [paymenyTools, setPaymentTools] = useState('NOT_SELECTED'); // انتخاب ابزار پرداخت فاکتور
  const [showDialog, setShowDialog] = useState(false); //دیالوگ مربوط به پرداخت اقساط 
  const [previewLoading, setPreviewLoading] = useState(false); // لودینگ مربوط به صدور فاکتور"
  const [previewData, setPreviewData] = useState({});// دیتای پیش نمایش صدور فاکتور
  const [isOpenPreview, setIsOpenPreview] = useState(false);// کلید دیالوگ پیش نمایش
  const [loadingBlock, setLoadingBlock] = useState(false);//  لودینگ مربوط به پیش نمایش  
  const [selectedProducts, setSelectedProducts] = useState([]); // کلید مربوط به مقدار جدول داخل صفحه
  const [voucherHashs, setVoucherHashs] = useState([]); // کلید مربوط به voucher استپ اول
  const [voucherType, setVoucherType] = useState('amount'); // "percentage" or "amount"
  const [totalPrice, setTotalPrice] = useState(0); // مقدار کل قیمت 
  const [enteredCaptcha, setEnteredCaptcha] = useState(''); // محتویات وارد شده در تکس باکس کپچا دیالوگ
  const [captchaId, setCaptchaId] = useState(null); // محتویات کپچا آیدی دیالوگ
  const [loanAgreement, setLoanAgreement] = useState(null); // "انتخاب اقساط "
  const [loanUserId, setLoanUserId] = useState(null); // "انتخاب اقساط "
  const [loadingField, setLoadingField] = useState(false);// لودینگ مربوط به select 
  const [phoneNumber, setPhoneNumber] = useState(null); // "تلفن بخش اقساط"
  const [resultInquery, setResultInquery] = useState(null); // نتایج استعلام
  const [loadContractsList, setLoadContractsList] = useState([]); // لیست قرارداد های تسهیلاتی
  const [loadContractsLoading, setLoadContractsLoading] = useState(0); //لودینگ مربوط به  لیست اعضا
  const [loadMembershipoading, setLoadMembershipoading] = useState(false); // لودینگ مربوط به دکمه ارسال اعضا
  const [tempFirstFormData, setTempFirstFormData] = useState([]); // لیست قرارداد های تسهیلاتی

  return {

    dataRow, setdataRow,
    totalList, setTotalList,
    toolsPayData, setToolsPayData,
    payDueDate, setPayDueDate,
    payerId, setPayerId,
    totalPrice, setTotalPrice,
    valueAmount, setValueAmount,
    amountPercentage, setAmountPercentage,
    voucherType, setVoucherType,
    loading,
    setLoading,
    filterParams,
    setFilterParams,
    size,
    setSize,
    page,
    setPage,
    filtersDeials, setFiltersDetail,
    isNewDialogOpen, setIsNewDialogOpen,
    isSubmitting, setIsSubmitting,
    activeStep, setActiveStep,
    paymenyTools, setPaymentTools,
    showDialog, setShowDialog,
    previewLoading, setPreviewLoading,
    previewData, setPreviewData,
    isOpenPreview, setIsOpenPreview,
    selectedProducts, setSelectedProducts,
    loadingBlock, setLoadingBlock,
    tempFirstFormData, setTempFirstFormData,
    loadMembershipoading, setLoadMembershipoading,
    loadContractsLoading, setLoadContractsLoading,
    loadContractsList, setLoadContractsList,
    resultInquery, setResultInquery,
    phoneNumber, setPhoneNumber,
    loadingField, setLoadingField,
    loanUserId, setLoanUserId,
    captchaId, setCaptchaId,
    voucherHashs, setVoucherHashs,
    enteredCaptcha, setEnteredCaptcha,
    loanAgreement, setLoanAgreement
  };
};

export default useCustomHook;
